module.exports = __webpack_public_path__ + "static/media/S1N12-5.13dee72e.svg";